import {Component, Input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TooltipModule} from 'primeng/tooltip';
import {Popover} from 'primeng/popover';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MEDIA_QUERY_DISPOSITIVO_TOUCH} from '../misc/dispositivo-touch';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
	selector: 'form-label',
	imports: [ReactiveFormsModule, TooltipModule, Popover],
	template: `
    <div class="flex align-items-center gap-1">
      <label [class.label-small]="labelSmall" [class.text-danger]="forceLabelDanger">{{ label }}</label>
      @if (infoTooltipText) {
        <i class="text-sm" [class]="tooltipIcon" [pTooltip]="!isMobile ? infoTooltipText : null" tooltipPosition="right"
           (click)="isMobile ? tooltipMobile.toggle($event) : null">
        </i>
        <p-popover #tooltipMobile>{{ infoTooltipText }}</p-popover>
      }
    </div>
	`,
	styles: [`
    .label-small {
      margin-bottom: 2px;
      font-size: small;
    }
	`]
})
export class FormLabelComponent {

	@Input() label: string;
	@Input() labelSmall = false; // per rimpicciolire il testo della label
	@Input() tooltipIcon = 'mdi mdi-information-variant-circle text-secondary'; // default icona "i" di informazioni
	@Input() infoTooltipText: string;
	@Input() forceLabelDanger = false;

	isMobile = false;

	constructor(private breakpointObserver: BreakpointObserver) {
		// touch (tablet / cellulare, a prescindere dalla larghezza) --> popover al tap invece del tooltip (v. dispositivo-touch.ts)
		this.breakpointObserver.observe(MEDIA_QUERY_DISPOSITIVO_TOUCH)
			.pipe(takeUntilDestroyed())
			.subscribe(result => this.isMobile = result.matches);
	}

}
